document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.brand-recommendations');
  if (!section) return;

  /* ----------------------------------------
   * Override check: if the manual recommended-products
   * section rendered products, hide this auto section.
   * ---------------------------------------- */
  var manualSection = document.querySelector('[data-recommended-has-products="true"]');
  if (manualSection) return;

  var vendor = section.getAttribute('data-vendor');
  var categoryTag = section.getAttribute('data-category-tag');
  var currentColour = section.getAttribute('data-current-colour') || '';
  var currentProductId = section.getAttribute('data-current-product-id');
  var currentHandle = section.getAttribute('data-current-handle');
  var productsToShow = parseInt(section.getAttribute('data-products-to-show'), 10) || 6;
  var grid = section.querySelector('[data-brand-rec-grid]');

  var hasMoreResults = false;

  if (!vendor || !categoryTag || !grid) return;

  /* ----------------------------------------
   * Step 1: Search for products by vendor
   * Uses alternate search template that outputs JSON.
   * Fetches multiple pages to ensure we get all matches.
   * ---------------------------------------- */
  /* Normalise vendor for comparison: strip &, extra spaces, lowercase */
  function normaliseVendor(v) {
    return v.toLowerCase().replace(/&/g, '').replace(/\s+/g, ' ').trim();
  }
  var vendorNormalised = normaliseVendor(vendor);

  var baseSearchUrl = '/search?view=brand-recs&type=product&q=' + encodeURIComponent(vendor);

  function fetchSearchPage(url) {
    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var jsonStart = text.indexOf('[');
        var jsonEnd = text.lastIndexOf(']');
        if (jsonStart === -1 || jsonEnd === -1) return [];
        var jsonStr = text.substring(jsonStart, jsonEnd + 1);
        return JSON.parse(jsonStr);
      })
      .catch(function () { return []; });
  }

  function fetchAllPages(url, allProducts, page) {
    var pageUrl = url + '&page=' + page;
    return fetchSearchPage(pageUrl).then(function (products) {
      if (!products || !products.length) return allProducts;
      allProducts = allProducts.concat(products);
      /* Stop after 3 pages (150 products) to avoid excessive requests */
      if (products.length < 50 || page >= 3) return allProducts;
      return fetchAllPages(url, allProducts, page + 1);
    });
  }

  fetchAllPages(baseSearchUrl, [], 1)
    .then(function (products) {
      if (!products || !products.length) return;

      /* ----------------------------------------
       * Step 2: Filter — same vendor + same category tag,
       * exclude current product.
       * ---------------------------------------- */
      var tagLower = categoryTag.toLowerCase().trim();

      var matches = products.filter(function (p) {
        if (String(p.id) === String(currentProductId)) return false;
        if (p.handle === currentHandle) return false;
        if (normaliseVendor(p.vendor) !== vendorNormalised) return false;

        var hasTag = false;
        for (var i = 0; i < p.tags.length; i++) {
          if (p.tags[i].toLowerCase().trim() === tagLower) {
            hasTag = true;
            break;
          }
        }
        return hasTag;
      });

      if (!matches.length) return;

      /* ----------------------------------------
       * Step 3: Sort by colour priority.
       * Pass 1 = has matching colour, Pass 2 = other colours.
       * ---------------------------------------- */
      if (currentColour) {
        var colourLower = currentColour.toLowerCase().trim();

        matches.sort(function (a, b) {
          var aHasColour = hasMatchingColour(a, colourLower) ? 0 : 1;
          var bHasColour = hasMatchingColour(b, colourLower) ? 0 : 1;
          return aHasColour - bHasColour;
        });
      }

      /* Trim to limit — track if there are more than shown */
      hasMoreResults = matches.length > productsToShow;
      var toFetch = matches.slice(0, productsToShow);

      /* ----------------------------------------
       * Step 4: Fetch each card via Section Rendering API.
       * /products/{handle}?sections=brand-rec-card
       * ---------------------------------------- */
      var cardPromises = toFetch.map(function (p) {
        return fetch('/products/' + p.handle + '?sections=brand-rec-card')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            return data['brand-rec-card'] || '';
          })
          .catch(function () { return ''; });
      });

      return Promise.all(cardPromises);
    })
    .then(function (cardHtmlArray) {
      if (!cardHtmlArray || !cardHtmlArray.length) return;

      /* Filter out empty results */
      var validCards = cardHtmlArray.filter(function (html) {
        return html && html.trim().length > 0;
      });

      if (!validCards.length) return;

      /* ----------------------------------------
       * Step 5: Inject cards into grid and show section.
       * ---------------------------------------- */
      validCards.forEach(function (html) {
        /* The section rendering API wraps output in a <div> with the section tag.
           Extract just the article content. */
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var article = temp.querySelector('.recommended-card');
        if (article) {
          grid.appendChild(article);
        } else {
          /* Fallback: inject the entire HTML */
          grid.insertAdjacentHTML('beforeend', html);
        }
      });

      /* Show the section and view-all link (only if more results exist) */
      section.style.display = '';
      if (hasMoreResults) {
        var viewAll = section.querySelector('[data-brand-rec-view-all]');
        if (viewAll) viewAll.style.display = '';
      }

      /* Trigger scroll-in animation */
      requestAnimationFrame(function () {
        initScrollReveal(section);
        initCardInteractions(section);
      });
    })
    .catch(function (err) {
      /* Silently fail — no recommendations is fine */
      console.warn('Brand recommendations:', err);
    });

  /* ----------------------------------------
   * Helpers
   * ---------------------------------------- */

  function hasMatchingColour(product, colourLower) {
    if (!product.colors || !product.colors.length) return false;
    for (var i = 0; i < product.colors.length; i++) {
      if (product.colors[i].toLowerCase().trim() === colourLower) return true;
    }
    return false;
  }

  /* ----------------------------------------
   * Scroll reveal (same as recommended-products)
   * ---------------------------------------- */
  function initScrollReveal(sectionEl) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sectionEl.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(sectionEl);
    } else {
      sectionEl.classList.add('is-visible');
    }
  }

  /* ----------------------------------------
   * Card interactions: hover flash, swatch swap, quick add
   * (same logic as section-recommended-products.js)
   * ---------------------------------------- */
  function initCardInteractions(sectionEl) {
    var cards = sectionEl.querySelectorAll('.recommended-card');
    var sourceProduct = sectionEl.getAttribute('data-current-handle') || '';

    sectionEl.addEventListener('click', function(e){
      var link = e.target.closest('a[href*="/products/"]');
      if (!link) return;
      var card = link.closest('.recommended-card');
      if (!card) return;
      if (!window.mss || !window.mss.track) return;
      var cardsList = Array.prototype.slice.call(sectionEl.querySelectorAll('.recommended-card'));
      window.mss.track('brand_rec_click', {
        source_product: sourceProduct,
        rec_product: card.getAttribute('data-product-id') || '',
        position: cardsList.indexOf(card) + 1
      });
    });

    cards.forEach(function (card) {
      var frame = card.querySelector('.recommended-card__frame');
      var primaryImg = card.querySelector('.js-recommended-image');
      var swatchButtons = card.querySelectorAll('.recommended-card__swatch-button');
      var quickAdd = card.querySelector('.recommended-card__quick-add');
      var defaultVariantId = card.getAttribute('data-default-variant-id');

      var defaultSrc = null;
      if (primaryImg) {
        defaultSrc =
          primaryImg.getAttribute('data-default-image') || primaryImg.getAttribute('src');
      }

      /* Disable OOS swatches + set default active */
      var defaultActiveBtn = null;
      swatchButtons.forEach(function (btn) {
        var isAvailable = btn.getAttribute('data-variant-available') === 'true';
        if (!isAvailable) {
          btn.classList.add('is-disabled');
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('tabindex', '-1');
        } else {
          btn.classList.remove('is-disabled');
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute('tabindex');
          if (!defaultActiveBtn) defaultActiveBtn = btn;
        }
      });

      if (defaultActiveBtn) {
        defaultActiveBtn.classList.add('is-active');
      }

      /* Image hover flash */
      if (frame && primaryImg) {
        var hasSecondaryImage = !!card.querySelector('.recommended-card__image.is-secondary');

        frame.addEventListener('mouseenter', function () {
          if (hasSecondaryImage) card.classList.add('is-flashing');
        });

        frame.addEventListener('mouseleave', function () {
          card.classList.remove('is-flashing');
          if (defaultSrc) primaryImg.setAttribute('src', defaultSrc);
          swatchButtons.forEach(function (btn) { btn.classList.remove('is-active'); });
          if (defaultActiveBtn) defaultActiveBtn.classList.add('is-active');
        });
      }

      /* Swatch hover + click */
      swatchButtons.forEach(function (button) {
        button.addEventListener('mouseenter', function () {
          if (button.classList.contains('is-disabled')) return;
          if (!primaryImg) return;
          // Locked-away swatches on exploded tiles have no data-color-name;
          // skip hover effects for them (click-only, keeps the tile's own ring active).
          if (!button.getAttribute('data-color-name')) return;

          var variantImg = button.getAttribute('data-variant-image');
          if (variantImg) {
            primaryImg.setAttribute('src', variantImg);
          } else if (defaultSrc) {
            primaryImg.setAttribute('src', defaultSrc);
          }

          swatchButtons.forEach(function (btn) { btn.classList.remove('is-active'); });
          button.classList.add('is-active');
          card.classList.remove('is-flashing');

          /* Sync size overlay with swatch colour */
          var swatchColor = button.getAttribute('data-color-name');
          if (swatchColor && card._sizeOverlayUpdate) {
            card._sizeOverlayUpdate(swatchColor);
          }
        });

        button.addEventListener('click', function () {
          if (button.classList.contains('is-disabled')) return;
          var variantUrl = button.getAttribute('data-variant-url');
          if (variantUrl) {
            window.location.href = variantUrl;
            return;
          }
          var productUrl = card.getAttribute('data-product-url');
          if (productUrl) window.location.href = productUrl;
        });
      });

      /* ── Size overlay logic ── */
      var sizeOverlay = card.querySelector('.recommended-card__size-overlay');
      if (sizeOverlay) {
        var overlayDataEl = card.querySelector('[data-size-overlay-data]');
        var overlayData = null;
        if (overlayDataEl) {
          try { overlayData = JSON.parse(overlayDataEl.textContent); } catch (e) {}
        }

        var sizePills = sizeOverlay.querySelectorAll('.size-pill');
        var productUrl = card.getAttribute('data-product-url') || '';
        var colourLabel = sizeOverlay.querySelector('[data-overlay-colour-label]');
        var prevArrow = sizeOverlay.querySelector('.size-overlay__arrow--prev');
        var nextArrow = sizeOverlay.querySelector('.size-overlay__arrow--next');

        var overlayColours = [];
        swatchButtons.forEach(function (btn) {
          if (!btn.classList.contains('is-disabled')) {
            var name = btn.getAttribute('data-color-name') || '';
            var img = btn.getAttribute('data-variant-image') || '';
            if (name) overlayColours.push({ name: name, image: img });
          }
        });

        var defaultColorName = defaultActiveBtn ? (defaultActiveBtn.getAttribute('data-color-name') || '') : '';
        var overlayColorIndex = 0;

        var secondaryIndex = 0;
        if (overlayColours.length > 1) {
          for (var si = 0; si < overlayColours.length; si++) {
            if (overlayColours[si].name !== defaultColorName) {
              secondaryIndex = si;
              break;
            }
          }
        }

        function updateSizePills(colorName) {
          if (!overlayData || !colorName) return;
          var colorData = overlayData[colorName];
          if (!colorData) return;
          sizePills.forEach(function (pill) {
            var sizeVal = pill.getAttribute('data-size-value');
            var info = colorData[sizeVal];
            if (info) {
              pill.classList.toggle('size-pill--oos', !info.available);
              if (info.variantId) pill.href = productUrl + '?variant=' + info.variantId;
            }
          });
        }

        function setOverlayColour(index) {
          if (!overlayColours.length) return;
          overlayColorIndex = ((index % overlayColours.length) + overlayColours.length) % overlayColours.length;
          var colour = overlayColours[overlayColorIndex];
          if (colourLabel) colourLabel.textContent = colour.name;
          updateSizePills(colour.name);
          if (primaryImg && colour.image) {
            primaryImg.setAttribute('src', colour.image);
            card.classList.remove('is-flashing');
          }
          swatchButtons.forEach(function (btn) {
            btn.classList.toggle('is-active', btn.getAttribute('data-color-name') === colour.name);
          });
        }

        if (prevArrow) {
          prevArrow.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            setOverlayColour(overlayColorIndex - 1);
          });
        }
        if (nextArrow) {
          nextArrow.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            setOverlayColour(overlayColorIndex + 1);
          });
        }

        if (frame) {
          // Removed: old mouseenter that auto-cycled colour on hover and reset
          // is-flashing. Arrow clicks still switch colours via setOverlayColour.

          frame.addEventListener('mouseleave', function () {
            if (defaultColorName) {
              for (var di = 0; di < overlayColours.length; di++) {
                if (overlayColours[di].name === defaultColorName) {
                  overlayColorIndex = di;
                  break;
                }
              }
            }
          });
        }

        sizePills.forEach(function (pill) {
          pill.addEventListener('click', function (e) { e.stopPropagation(); });
        });

        card._sizeOverlayUpdate = function (colorName) {
          for (var ui = 0; ui < overlayColours.length; ui++) {
            if (overlayColours[ui].name === colorName) { overlayColorIndex = ui; break; }
          }
          if (colourLabel) colourLabel.textContent = colorName;
          updateSizePills(colorName);
        };

        if (!defaultColorName && overlayData) {
          var firstColor = Object.keys(overlayData)[0];
          if (firstColor) updateSizePills(firstColor);
        } else if (defaultColorName && overlayData) {
          updateSizePills(defaultColorName);
        }
      }

      /* Quick add click */
      if (quickAdd) {
        quickAdd.addEventListener('click', function (e) {
          var isSoldOut =
            quickAdd.classList.contains('is-sold-out') ||
            quickAdd.getAttribute('aria-disabled') === 'true';
          if (isSoldOut) return;

          var productUrl = card.getAttribute('data-product-url') || '';
          var handle = getHandleFromUrl(productUrl);
          var requiresSelection = card.getAttribute('data-requires-selection') === 'true';
          var hasSwatches = !!card.querySelector('.recommended-card__swatches');
          var canQuickView = window.QuickView && typeof window.QuickView.open === 'function';
          var shouldOpenQuickView = canQuickView && handle && (requiresSelection || hasSwatches);

          if (shouldOpenQuickView) {
            e.preventDefault();
            window.QuickView.open(handle);
            return;
          }

          if ((requiresSelection || hasSwatches) && productUrl) {
            e.preventDefault();
            window.location.href = productUrl;
            return;
          }

          if (!(window.CartAPI && typeof window.CartAPI.addToCart === 'function')) return;

          e.preventDefault();
          if (!defaultVariantId) return;

          quickAdd.setAttribute('aria-busy', 'true');
          window.CartAPI
            .addToCart({ items: [{ id: Number(defaultVariantId), quantity: 1 }] })
            .catch(function () {
              if (productUrl) window.location.href = productUrl;
            })
            .finally(function () {
              quickAdd.removeAttribute('aria-busy');
            });
        });
      }
    });
  }

  function getHandleFromUrl(url) {
    if (!url) return '';
    var parts = url.split('/products/');
    if (parts.length < 2) return '';
    return parts[1].split('?')[0].split('#')[0];
  }
});
